export type IBiService = ReturnType<typeof biService>;

/* @ngInject */
export function biService($log, wixSdk) {
  const src = 9;
  const biToken = getBiToken() || getRandomGuid();
  const visitorId = getAnonymousUserId() || getRandomGuid();
  const rootUrl = '//frog.wix.com/music-ugc?';
  const instanceID = getInsantecId();

  return {
    rsvp,
    sendButtonEvent,
    tickets,
  };

  function getInsantecId() {
    try {
      return wixSdk.Utils.getInstanceId();
    } catch (ex) {
      $log.error(ex);
    }
  }

  function getBiToken() {
    try {
      return wixSdk.Utils.getInstanceValue('biToken');
    } catch (ex) {
      $log.error(ex);
    }
  }

  function getAnonymousUserId() {
    try {
      return wixSdk.Utils.getInstanceValue('aid');
    } catch (ex) {
      $log.error(ex);
    }
  }

  function rsvp(artistName) {
    const evid = 210;
    const url = `${rootUrl}src=${src}&evid=${evid}&artist_name=${artistName}&biToken=${biToken}&instance_id=${instanceID}&visitor_id=${visitorId}`;
    const img = new Image();
    img.src = url;
  }

  function tickets(artistName) {
    const evid = 211;
    const url = `${rootUrl}src=${src}&evid=${evid}&artist_name=${artistName}&biToken=${biToken}&instance_id=${instanceID}&visitor_id=${visitorId}`;
    const img = new Image();
    img.src = url;
  }

  function sendButtonEvent(artistName, buttonType) {
    const evid = 228;
    const url = `${rootUrl}src=${src}&evid=${evid}&artist_name=${artistName}&biToken=${biToken}&instance_id=${instanceID}&visitor_id=${visitorId}&target=${buttonType}`;
    const img = new Image();
    img.src = url;
  }

  function getRandomGuid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }

    return `badabada-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
  }
}
